import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, MapPin } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[100svh] flex items-center pt-20 overflow-hidden" data-id="element-169">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-170">
        <img src="https://cdn.magicpatterns.com/uploads/srhDuKcARz3RafX3t5wi46/CEO.png" alt="Luciano Barber Shop" className="absolute inset-0 w-full h-full object-cover object-[center_20%] md:object-[center_25%] md:scale-110" data-id="element-171" />

        {/* Cinematic overlay stack */}
        <div className="absolute inset-0 bg-gradient-to-b from-dark/90 via-dark/65 to-dark z-10" data-id="element-172" />
        <div className="absolute inset-0 hidden md:block bg-[linear-gradient(90deg,rgba(10,10,10,0.75)_0%,rgba(10,10,10,0.2)_30%,rgba(10,10,10,0.2)_70%,rgba(10,10,10,0.75)_100%)] z-10" data-id="element-173" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(201,168,76,0.18)_0%,transparent_55%)] z-10" data-id="element-174" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex flex-col items-center text-center" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-176">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight text-white mb-3" data-id="element-177">
            Luciano Barber <span className="text-gold" data-id="element-178">/</span> Academia
          </h1>

          <p className="text-base md:text-lg text-gold/80 font-light tracking-[0.2em] uppercase mb-8" data-id="element-179">
            Una experiencia única
          </p>

          <p className="text-xl md:text-2xl text-gray-300 font-light mb-8 max-w-2xl mx-auto" data-id="element-180">
            Cortes de todos los estilos • Color • Formación profesional.
          </p>

          <div className="flex justify-center mb-10" data-id="element-181">
            <p className="inline-block bg-gold/15 border border-gold/40 text-gold text-sm md:text-base font-semibold px-5 py-2.5 rounded-full shadow-[0_0_25px_rgba(201,168,76,0.25)] max-w-xl" data-id="element-182">
              Reservá tu turno online o consultá cupos de{' '}
              <span className="text-gold-light font-bold" data-id="element-183">
                Cursos Iniciales 2026
              </span>
              .
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-184">
            <a href="#servicios" className="group relative flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-dark font-bold py-4 px-8 rounded-full w-full sm:w-auto transition-all duration-300 overflow-hidden shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] transform hover:-translate-y-1" data-id="element-185">
              <Scissors size={20} className="group-hover:scale-110 transition-transform" data-id="element-186" />
              <span data-id="element-187">Ver servicios</span>
            </a>

            <a href="#sucursales" className="group flex items-center justify-center gap-2 bg-transparent border border-white/30 hover:border-gold text-white hover:text-gold font-semibold py-4 px-8 rounded-full w-full sm:w-auto transition-all duration-300" data-id="element-188">
              <MapPin size={20} className="group-hover:scale-110 transition-transform" data-id="element-189" />
              <span data-id="element-190">Ver sucursales</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}